import { render } from "./App.vue?vue&type=template&id=1283b2ef"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1283b2ef&lang=css"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__